import { Header } from '../components';

const PlatformAnalysis = () => {
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header title="Platform Analysis" />
      <p>Platform Analysis</p>
    </div>
  );
};

export default PlatformAnalysis;
